// Mega Menu

// Allows you to click the parent item on mobile and go straight to that page rather than taking two clicks, first to expand sub items, second to go to the page.

jQuery( function( $ ) {

    function menuSetup() {
        // Remove the toggle link from the text
        $('#mega-menu-main-nav .mega-menu-item-has-children a.mega-menu-link').unbind();

        // This version worked for targeting solutions, since it has differnent classes.
        // $('.mega-current-page-ancestor .mega-indicator').click(function(event) {

        $('.mega-menu-item-has-children .mega-menu-link, .mega-indicator').click(function(event) {
            alert('hey');
            $(this).trigger('mousedown');
            /*
				if (!$(this).parent().parent().hasClass('mega-toggle-on')) {
					  event.preventDefault();
					  var panelToShow = $(this).parent();
					  $('#mega-menu-main-nav').data('maxmegamenu').showPanel(panelToShow);
				 }
				 */
        });
        console.log('event set 2');

        // Hide the off-canvas menu on browser resize
        $(window).resize(function() {

            // Removes the no scroll class from the body if it's been applied
            $('body').removeClass("no-scroll");

            if ( $(window).width() > 1020) {
                // Hides the menu
                $('.off-canvas').removeClass('is-open');
                // Hides the overlay
                $('.js-off-canvas-overlay').removeClass('is-visible');

            }
            else {
                //Add your javascript for small screens here
            }
        });
    }
});